import React, { Fragment } from 'react';

import lockbox2 from '../../../images/lockbox2.jpg';
import lockbox3 from '../../../images/lockbox3.jpg';
import lockbox4 from '../../../images/lockbox4.jpg';
import lockbox5 from '../../../images/lockbox5.jpg';
import lockbox6 from '../../../images/lockbox6.jpg';
import lockbox7 from '../../../images/lockbox7.jpg';
import lockbox8 from '../../../images/lockbox8.jpg';

const OpenBox = ({city = "toronto"}) => (
  <Fragment>
    <p>
      All lock boxes are opened by a 5-digit lock code which you will receive through the Dashboard prior to your booking. To operate the lock boxes, follow these instructions:
    </p>
    <ol>
      <li>Open the black cover flap to expose the number code pad</li>
      <div>
        <img className="lockbox-image" src={lockbox2} alt="LockBox" />
        <img className="lockbox-image" src={lockbox3} alt="LockBox" />
      </div>
      <li>Reset the lock box by pressing the black lever (between 0 and *) so it makes a click noise</li>
      <img className="lockbox-image" src={lockbox4} alt="LockBox" />
      <li>
        Type 5-digit lock box code and then push the large top silver lever button down and the box will open so you can
        retrieve the car key.
      </li>
      <div className="lockbox-flex">
        <div>
          <img className="lockbox-image" src={lockbox5} alt="LockBox" />
        </div>
        <div>
          <img className="lockbox-image" src={lockbox6} alt="LockBox" />
        </div>
      </div>

      <li>
        To close the box after retrieving the car key, reset the lock box code by pressing the black lever (between 0
        and *) so it makes a click noise again
      </li>
      <li>Type in the 5-digit lock box code again and use the large top silver lever button to close the box.</li>
      <div className="lockbox-flex">
        <div>
          <img className="lockbox-image" src={lockbox7} alt="LockBox" />
          <p className="lockbox-p-block">CLOSED CORRECTLY</p>
        </div>
        <div>
          <img className="lockbox-image" src={lockbox8} alt="LockBox" />
          <p className="lockbox-p-block">NOT CLOSED CORRECTLY</p>
        </div>
      </div>
    </ol>
    <strong>NOTE: Failing to close the lock box correctly will result in a $100 fine.</strong>
  </Fragment>
);

export default OpenBox;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/OpenBox.js